
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contrato/politica-seguranca",
      function () {
        return require("private-next-pages/contrato/politica-seguranca/index.js");
      }
    ]);
  